import styled from "styled-components";

const AudioBlock = styled.div`
  display: flex;
`;

AudioBlock.Control = styled.div``;
AudioBlock.Info = styled.div`
  padding-left: 15px;
  padding-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
AudioBlock.Preview = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  align-items: center;
  justify-content: center;
  background-image: url(${(props) => props.previewImage});
  background-position: center;
  background-size: cover;
`;

AudioBlock.Control.Button = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
`;

export { AudioBlock };
